import { disablePageScroll, enableScroll } from '../utils/scroll';

export default () => {
  const solutions = document.querySelectorAll('.solutions');

  solutions.forEach((block) => {
    const menuWrapper = block.querySelector('.solutions__menu-wrapper');
    const overlay = block.querySelector('.solutions__menu-overlay');
    const headItems = block.querySelectorAll('.solutions__head-item');
    const bodyItems = block.querySelectorAll('.solutions__body-item');
    const current = block.querySelector('.solutions__current');

    if (!current) return;

    current.addEventListener('click', () => {
      menuWrapper.classList.add('visible');
      disablePageScroll(true);
    });

    overlay.addEventListener('click', () => {
      menuWrapper.classList.remove('visible');
      enableScroll();
    });

    let itemChange = (index) => {
      for (let i = 0; i < bodyItems.length; i++) {
        headItems[i].classList.remove('active');
        bodyItems[i].classList.remove('active');
      }

      headItems[index].classList.add('active');
      bodyItems[index].classList.add('active');
      current.innerHTML = headItems[index].innerHTML;
    };

    for (let i = 0; i < bodyItems.length; i++) {
      headItems[i].addEventListener('click', function(event) {
        if (headItems[i].classList.contains('active')) return;
        itemChange(i);

        setTimeout(function() {
          menuWrapper.classList.remove('visible');
          enableScroll();
        }, 200);
      });
    }

    // fix lists
    const listItems = block.querySelectorAll('.solutions__body-content li');
    listItems.forEach((li) => {
      const hasInnerList = li.querySelectorAll('ul').length > 0;
      if (hasInnerList) {
        li.classList.add('with-children')
      }
    });
  });
};
